<template>
  <el-dialog
    title="图片处理"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
    :visible.sync="visible"
    width="600px"
    @close="handleClose">
    <div class="failText" v-if="failText">
        <span class="label">上传失败的图片:</span><br>
        {{failText}}
    </div>
    <div class="title">上传成功的图片 <span class="tip">(可增删、拖动排序)</span></div>
    <MutiImgUpload
        :limitNums="30"
        :mainImgNums="0"
        v-model="imgs" />

    <template slot="footer">
        <span>
            <el-button type="primary" @click="handleOk">确定</el-button>
        </span>
    </template>
  </el-dialog>
</template>

<script>
import MutiImgUpload from '@/components/Uploads/MutiImgUpload'

/***** 用于处理图片上传完成后是否需要进行排序或者继续上传补充图片 *****
/**
 * method_open
 */
export default {
    name: 'handleFinishedImg',
    components: {MutiImgUpload},
    data() {
        return {
            visible: false,
            imgs: [],
            failImgs: [],
            cb: null
        }
    },
    computed: {
        failText() {
            return this.failImgs.join(',')
        }
    },
    methods: {
        method_open(finishedImageArr, cb) {
            this.cb = cb;
            let imgs = []
            let failImgs = []
            finishedImageArr.forEach(item => {
                item.success ? imgs.push(item.data) : failImgs.push(item.data);
            })
            // 有一种情况不需要做图片处理
            // finishedImageArr总数就只有一张，若是失败了直接提示失败信息即可
            if (finishedImageArr.length === 1) {
                imgs.length ? this.cb([...imgs]) : this.$message.error(`文件${failImgs[0]}上传失败`)
                return ;
            }
            this.imgs = imgs
            this.failImgs = failImgs
            this.visible = true
        },
        handleClose() {
            this.imgs = []
            this.failImgs = []
            this.cb = null
        },
        handleOk() {
            this.cb && this.cb([...this.imgs]);
            this.visible = false
        }
    }
}
</script>

<style lang="scss" scoped>
.failText {
    margin-bottom: 20px;
    .label {
        font-weight: bold;
    }
}
.title {
    font-weight: bold;
    margin-bottom: 5px;
    .tip {
        margin-left: 10px;
        font-weight: normal;
        color: #ccc
    }
}
</style>